export default "__VITE_ASSET__RunPSY_F__"